import CommonResourcesEn from "../login-registration/CommonResources.En";

export const ForgetPasswordFormResourcesEn = {
    backToLogin: "Back to login",
    modalHeaderText: "Forgot your password?",
    message: "Enter your e-mail below, we will send you a link to reset your password.",
    sentMessageOne: "E-mail has been sent to: ",
    sentMessageTwo: "Check your mail and use the link to define new password.",
    recoveryButton: "Send",
    emailWatermark: CommonResourcesEn.email,
    emailRequiredError: "E-mail is required",
    emailInvalidError: "Please enter valid e-mail address",
};
